import { Box, Group } from '@mantine/core';
import type { MonitorActionSendEmail } from '@repo/api-codegen';
import { SettingsBlock, SettingsButton } from '@repo/common/components';
import { Icon, IconButton, Text, TextInput } from '@repo/foundations';

interface MonitorEmailFormProps {
	value: MonitorActionSendEmail;
	onChange: (value: MonitorActionSendEmail) => void;
	isAddingEmail: boolean;
	newEmail: string;
	emailError: string;
	onSetIsAddingEmail: (isAdding: boolean) => void;
	onSetNewEmail: (email: string) => void;
	onAddEmail: () => void;
	onRemoveEmail: (email: string) => void;
}

export function MonitorEmailForm({
	value,
	onChange,
	isAddingEmail,
	newEmail,
	emailError,
	onSetIsAddingEmail,
	onSetNewEmail,
	onAddEmail,
	onRemoveEmail,
}: MonitorEmailFormProps) {
	const emailCount = value?.emails?.length || 0;

	return (
		<Box>
			<Box mb="4xl">
				<SettingsButton
					iconName="plus"
					variant="tertiary"
					title="Emails"
					onClick={() => onSetIsAddingEmail(true)}
					tooltip="Add email"
					description="Additional emails to notify"
					aria-label="Add email address"
				/>

				{value?.emails?.map((email) => (
					<SettingsBlock
						key={email}
						title={
							<Group noWrap align="center" spacing="xs">
								<Icon name="mail" color="icon/secondary/default" />
								<Text weight="semibold">{email}</Text>
							</Group>
						}
						description={null}
						rightComponent={
							<IconButton
								iconName="x"
								variant="tertiary"
								tooltip="Remove email"
								onClick={() => onRemoveEmail(email)}
							/>
						}
					/>
				))}

				{isAddingEmail && (
					<SettingsBlock
						key="add"
						title={
							<Group>
								<TextInput
									placeholder="Enter email address"
									value={newEmail}
									onChange={(e) => onSetNewEmail(e.target.value)}
									error={emailError}
									size="sm"
									style={{ flex: 1 }}
									autoFocus
								/>
							</Group>
						}
						rightComponent={
							<IconButton
								iconName="plus"
								variant="default"
								size="sm"
								onClick={() => onAddEmail()}
								disabled={!newEmail}
							/>
						}
					/>
				)}
			</Box>
		</Box>
	);
}
